import { RecoveryPage } from "./recovery-page";
import { RecoverableControlImpl, RecoverableControl } from "./recoverable-control";
import { LoggingService } from "../sdServices/loggingSvc";
import { ContextService } from "../sdServices/context/context-service";
// @ngInject
let recoveryModule = angular
  .module("sdApp.Recovery", [])
  .component("recoveryPage", {
    controller: RecoveryPage,
    controllerAs: "$ctrl",
    templateUrl: "../ServiceDesk/recovery/recovery-page.html"
  })
  .decorator(
    "$controller",
    ($delegate: ng.IControllerService, contextService: ContextService, loggingService: LoggingService) => {
      return (constructor: any, locals: any, later: any, identifier: any) => {
        let controller = $delegate(constructor, locals, later, identifier);
        /**
         * If the 'later' parameter is specified, then a function which returns an instance is expected.
         * Otherwise we should return the instance.
         */
        if (later) {
          let returnFn = (...args: any[]) => {
            let constructedController: RecoverableControlImpl = (<any>controller).apply(undefined, args);
            if (constructedController.$getRecoverableFields) {
              new RecoverableControl(locals.$scope, contextService, constructedController, loggingService);
            }
            return constructedController;
          };
          return angular.extend(returnFn, controller);
        } else {
          if ((<RecoverableControlImpl>controller).$getRecoverableFields) {
            new RecoverableControl(locals.$scope, contextService, <any>controller, loggingService);
          }
          return controller;
        }
      };
    }
  );

export default recoveryModule;
